// Doorklik naar het project in Bouwflow (SPEC 27okt 5). Zonder geldige interne id: geen dode link maar
// een grijs icoon met tooltip "geen Bouwflow-koppeling".
import type { ReactNode } from 'react';
import { bouwflowProjectUrl, GEEN_BOUWFLOW_KOPPELING } from '../lib/bouwflow';

export function BouwflowLink({ bouwflowProjectId, children, className = '', stopPropagation = true }: {
  bouwflowProjectId: number | null | undefined;
  /** Tekst naast het icoon, bv. het P-nummer. */
  children?: ReactNode;
  className?: string;
  /** Klik niet laten doorgaan naar een klikbare rij of kaart eronder. */
  stopPropagation?: boolean;
}) {
  const url = bouwflowProjectUrl(bouwflowProjectId);
  if (!url) {
    return (
      <span className={`inline-flex items-center gap-1 ${className}`} title={GEEN_BOUWFLOW_KOPPELING} aria-label={`${typeof children === 'string' ? children + ': ' : ''}${GEEN_BOUWFLOW_KOPPELING}`}>
        {children}
        <span aria-hidden className="text-secondary/60">↗</span>
      </span>
    );
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
      className={`inline-flex items-center gap-1 hover:underline focus-visible:underline ${className}`}
      title="Open dit project in Bouwflow (nieuw tabblad)"
    >
      {children}
      <span aria-hidden>↗</span>
    </a>
  );
}
